import React from 'react';
import ChrComparison from '../../../Reports/templates/ChrComparison';
import ChrAlert from '../../../../generic/PageUI/Basic/Metric/ChrAlert';

const ChartDataLabel = (props) => {
  const { basic, value } = props;
  if (basic) return value;

  const { previousPeriod, renderedAsString, alert = {} } = props;
  return (
    <div className="d-flex flex-gap-10 align-items-center">
      <div>
        { value }
      </div>
      <ChrAlert {...alert} containerLocator="#cjs-management-report-v2" renderedAsString={renderedAsString} />
      { previousPeriod && <ChrComparison
        renderedAsString={ renderedAsString }
        changeSentiment={ previousPeriod.insights.sentiment }
        changeValue={ previousPeriod.insights.changeValue }
        changeDirection={ previousPeriod.insights.direction }
        periodOne={{ dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value }}
        periodTwo={{ dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value }}
      /> }
    </div>
  );
};

export default ChartDataLabel;
